var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 17.5C7.56536 17.5 8.125 16.9404 8.125 16.25C8.125 15.5596 7.56536 15 6.875 15C6.18464 15 5.625 15.5596 5.625 16.25C5.625 16.9404 6.18464 17.5 6.875 17.5Z",
    fill: "#3FD645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 17.5C16.3154 17.5 16.875 16.9404 16.875 16.25C16.875 15.5596 16.3154 15 15.625 15C14.9346 15 14.375 15.5596 14.375 16.25C14.375 16.9404 14.9346 17.5 15.625 17.5Z",
    fill: "#3FD645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8438 4.71797C17.7559 4.61057 17.6453 4.52406 17.5199 4.46474C17.3945 4.40542 17.2575 4.37476 17.1187 4.375H5.23008L4.99063 3.01641C4.96509 2.87169 4.88938 2.7406 4.7768 2.64616C4.66421 2.55172 4.52195 2.49997 4.375 2.5H1.875C1.70924 2.5 1.55027 2.56585 1.43306 2.68306C1.31585 2.80027 1.25 2.95924 1.25 3.125C1.25 3.29076 1.31585 3.44973 1.43306 3.56694C1.55027 3.68415 1.70924 3.75 1.875 3.75H3.85078L5.63438 13.8586C5.65991 14.0033 5.73562 14.1344 5.8482 14.2288C5.96079 14.3233 6.10305 14.375 6.25 14.375H16.25C16.4158 14.375 16.5747 14.3092 16.6919 14.1919C16.8092 14.0747 16.875 13.9158 16.875 13.75C16.875 13.5842 16.8092 13.4253 16.6919 13.3081C16.5747 13.1908 16.4158 13.125 16.25 13.125H6.77422L6.55391 11.875H15.9937C16.2105 11.8747 16.4205 11.7996 16.5882 11.6623C16.7559 11.525 16.871 11.3339 16.9141 11.1215L18.0391 5.49648C18.0662 5.36035 18.0627 5.2199 18.0289 5.08527C17.9952 4.95064 17.9319 4.82518 17.8438 4.71797Z",
    fill: "#3FD645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.2e38379993ce1de70baa69d5efe7f480.svg";
export { ForwardRef as ReactComponent };